import withMyPerformanceData from "../../myPerformance/withMyPerformanceData";
import MyPerformance from "./MyPerformance";

export default withMyPerformanceData(MyPerformance);
